import {
  SearchItemsResponse,
  CursorSearch,
} from './src/restaurants-menus-v1-item-items.universal';

export * from './src/restaurants-menus-v1-item-items.universal.js';

/** @hidden */
export type ItemSearch = {};

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of items given the provided filtering, paging, and sorting.
 *
 * ## Defaults
 * Search Items has the following default settings, which you can override:
 *
 * - Sorted by `createdDate` in ascending order.
 * - `paging.limit` set to `500`.
 * - `paging.offset` set to `0`.
 * @param search - Search options.
 * @public
 * @requiredField search
 * @permissionId RESTAURANTS.ITEM_READ
 * @applicableIdentity APP
 * @fqn com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.SearchItems
 */
export declare function searchItems(
  search: CursorSearch
): Promise<SearchItemsResponse>;
